import DiscountType, { IDiscountTypeAPI } from '@/common/models/misc-api-models/DiscountType';
import { DASH } from '@/globals';
import formatNumber from '@/utils/NumberFormatter';
import Validatable from '@/validator/Validatable';

export interface ILineItemDiscountAPI {
  lineitemdiscount_id?: number;
  lineitem_id: number;
  discounttype_id: number;
  discounttype?: IDiscountTypeAPI;
  value: number;
}

interface ILineItemDiscount {
  lineItemID: number;
  discountTypeID: number;
  discountType?: DiscountType;
  value: number;
}

export default class LineItemDiscount extends Validatable {
  lineItemID: number;

  discountTypeID: number;

  discountType?: DiscountType;

  value: number;

  constructor(id = -1, lineItemID = -1, discountTypeID = -1, discountType?: DiscountType, value = 0) {
    super();
    this.id = id;
    this.lineItemID = lineItemID;
    this.discountTypeID = discountTypeID;
    this.discountType = discountType;
    this.value = value;
  }

  get valueFormatted(): string {
    if (Number.isNaN(this.value)) {
      return DASH;
    }
    return formatNumber(this.value, '0.00%');
  }

  get valueTimes100(): string {
    if (Number.isNaN(this.value)) {
      return DASH;
    }
    return `${Math.round(this.value * 10000) / 100}`;
  }

  set valueTimes100(val: number) {
    if (Number.isNaN(val)) {
      return;
    }
    this.value = Math.round(val * 100) / 10000;
  }

  static fromObject(obj: ILineItemDiscount): LineItemDiscount {
    return super.fromObject(obj, new LineItemDiscount());
  }

  static fromApi(apiObject: ILineItemDiscountAPI): LineItemDiscount {
    return new LineItemDiscount(
      apiObject.lineitemdiscount_id,
      apiObject.lineitem_id,
      apiObject.discounttype_id,
      apiObject.discounttype !== undefined ? DiscountType.fromApi(apiObject.discounttype) : null,
      apiObject.value,
    );
  }

  toApi(): ILineItemDiscountAPI {
    return {
      lineitemdiscount_id: this.id >= 0 ? this.id : undefined,
      lineitem_id: this.lineItemID,
      discounttype_id: this.discountType !== null ? this.discountType.id : this.discountTypeID,
      value: this.value,
    };
  }

  static validatorCreateRules(): { [key: string]: string } {
    return {
      discountTypeID: 'required',
      value: 'required|numeric:float|min_value:0|max_value:1',
    };
  }
}
